import { create } from 'zustand';

import type { Nullable } from 'utils/values';

export type AppState = {
  isDraggingColumn: boolean;
  draggingColumnIndex?: number;

  leftShiftKeyDownInGrid: boolean;
  setLeftShiftDown: (isDown: boolean) => void;

  hoveredCellResultSetId: Nullable<string>;
  hoveredCellColumnIndex: Nullable<number>;
  hoveredCellRowIndex: Nullable<number>;

  setIsDragging: (isDraggingColumn: boolean, draggingColumn?: number) => void;

  setHoveredCell: (resultSetId: string, columnIndex: number, rowIndex: number) => void;
  clearHoveredCell: () => void;

  spaceBarDown: boolean;
  setSpaceBarDown: (isPressed: boolean) => void;

  deleteDown: boolean;
  setDeleteDown: (isPressed: boolean) => void;

  appConsoleLogEnabled: boolean;
  enableAppConsoleLogs: (enable: boolean) => void;
  logMessages: AppConsoleLogMessage[];
  log: (message: AppConsoleLogMessage) => void;
  clearLog: () => void;
};

export type AppConsoleLogMessage = {
  message: string;
  severity: EConsoleMessageSeverity;
  date: Date;
};

export enum EConsoleMessageSeverity {
  Debug = 0,
  Trace = 1,
  Warning = 2,
  Critical = 3
}

export const APP_STATE = create<AppState>((set) => ({
  leftShiftKeyDownInGrid: false,
  setLeftShiftDown: (isDown: boolean) => set({ leftShiftKeyDownInGrid: isDown }),

  isDraggingColumn: false,
  setIsDragging: (isDraggingColumn: boolean, draggingColumnIndex?: number) =>
    set({ isDraggingColumn, draggingColumnIndex }),

  hoveredCellResultSetId: undefined,
  hoveredCellColumnIndex: undefined,
  hoveredCellRowIndex: undefined,
  setHoveredCell: (resultSetId: string, columnIndex: number, rowIndex: number) =>
    set({
      hoveredCellResultSetId: resultSetId,
      hoveredCellColumnIndex: columnIndex,
      hoveredCellRowIndex: rowIndex
    }),
  clearHoveredCell: () =>
    set({
      hoveredCellResultSetId: undefined,
      hoveredCellColumnIndex: undefined,
      hoveredCellRowIndex: undefined
    }),

  spaceBarDown: false,
  setSpaceBarDown: (isPressed: boolean) => set({ spaceBarDown: isPressed }),
  deleteDown: false,
  setDeleteDown: (isPressed: boolean) => set({ deleteDown: isPressed }),

  appConsoleLogEnabled: false,
  enableAppConsoleLogs: (value: boolean) => set({ appConsoleLogEnabled: value }),

  logMessages: [],
  log: (message: AppConsoleLogMessage) =>
    set(({ logMessages, appConsoleLogEnabled }) => {
      if (appConsoleLogEnabled) {
        console.log(message.message);
      }
      return { logMessages: appConsoleLogEnabled ? [...logMessages, message] : logMessages };
    }),
  clearLog: () => set({ logMessages: [] })
}));
